export default __webpack_public_path__ + "static/media/dashboard-active-icon.89d5ab25.svg";